import { getAppHost, getAppEndpointVersion } from 'helpers'
import axios from './axiosInstance'

// List AI Agents
export const list = async (app, appSettings, pageNo = 1, searchText = '') => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/agents`
     
    const params = new URLSearchParams()
    if (pageNo) params.append('page', pageNo)
    if (searchText) params.append('search', searchText)
    
    const url = params.toString() ? `${baseURL}?${params.toString()}` : baseURL
    
    const response = await axios.get(url, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}

// Update AI Agent
export const update = async (app, appSettings, agentId, agentData) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/agents/${agentId}`
    
    const response = await axios.patch(baseURL, agentData, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}

// Delete AI Agent
export const remove = async (app, appSettings, agentId) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/ai-agents/agents/${agentId}`
    
    const response = await axios.delete(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}
